import reduxConnector from 'root/src/shared/util/reduxConnector'

import dropEventSelector from 'root/src/client/logic/dropEvent/selectors/dropEventSelector'
import isMobileResSelector from 'root/src/client/logic/app/selectors/isMobileResSelector'
import isAuthenticated from 'root/src/client/logic/auth/selectors/isAuthenticated'
import myProfileSelector from 'root/src/client/logic/route/selectors/myProfileSelector'
import hasProfileSelector from 'root/src/client/logic/route/selectors/hasProfileSelector'
import followerCountSelector from 'root/src/client/logic/userData/selectors/followerCountSelector'
import isAdminSelector from 'root/src/client/logic/auth/selectors/isAdminSelector'
import isBrandUserSelector from 'root/src/client/logic/static/selectors/isBrandUserSelector'
import userIdSelector from 'root/src/client/logic/auth/selectors/userIdSelector'
import ccvSelector from 'root/src/client/logic/app/selectors/ccvSelector'
import platformsSelector from 'root/src/client/logic/dropEvent/selectors/platformsSelector'
import platformIdSelector from 'root/src/client/logic/userData/selectors/platformIdSelector'
import platformSelector from 'root/src/client/logic/userData/selectors/platformSelector'
import userCampaignDataSelector from 'root/src/client/logic/app/selectors/userCampaignDataSelector'
import canEarnPointsSelector from 'root/src/client/logic/dropEvent/selectors/canEarnPointsSelector'
import creatorCampaignPointsLimitSelector from 'root/src/client/logic/app/selectors/creatorCampaignPointsLimitSelector'
import tokensSelector from 'root/src/client/logic/api/selectors/tokensSelector'

import setEmailSubscriptionDrop from 'root/src/client/logic/dropEvent/thunks/setEmailSubscriptionDrop'
import setInput from 'root/src/client/logic/form/thunks/setInput'
import redirectAndPrePopulate from 'root/src/client/logic/app/thunks/redirectAndPrePopulate'
import displayModal from 'root/src/client/logic/modal/thunks/displayModal'
import dispatcher from 'root/src/client/logic/app/thunks/dispatcher'
import currentRouteParams from 'root/src/client/logic/route/selectors/currentRouteParams'
import followerCountByPlatformSelector from 'root/src/client/logic/userData/selectors/followerCountByPlatformsSelector'
import { displayHowToEarnPointsModal } from 'root/src/client/logic/dropEvent/thunks/displayHowToEarnPointsModal'
import { isCreatorSelector } from 'root/src/client/logic/auth/selectors/isCreatorSelector'
import { parentUserIdSelector } from 'root/src/client/logic/auth/selectors/parentUserIdSelector'

export default reduxConnector(
	[
		['dropEvent', dropEventSelector],
		['isMobileRes', isMobileResSelector],
		['isAuthenticated', isAuthenticated],
		['isAdmin', isAdminSelector],
		['isBrand', isBrandUserSelector],
		['isCreator', isCreatorSelector],
		['platforms', platformsSelector],
		['userId', userIdSelector],
		['myProfileRoute', myProfileSelector],
		['hasProfile', hasProfileSelector],
		['followerCount', followerCountSelector],
		['followerCountByPlatforms', followerCountByPlatformSelector],
		['ccv', ccvSelector],
		['creatorCampaignPointsLimit', creatorCampaignPointsLimitSelector],
		['platformId', platformIdSelector],
		['platform', platformSelector],
		['userCampaignData', userCampaignDataSelector],
		['canEarnPoints', canEarnPointsSelector],
		['currentRouteParams', currentRouteParams],
		['parentUserId', parentUserIdSelector],
		['tokens', tokensSelector],
	],
	[
		['setInput', setInput],
		['redirectAndPrePopulate', redirectAndPrePopulate],
		['displayModal', displayModal],
		['setEmailSubscriptionDrop', setEmailSubscriptionDrop],
		['displayModal', displayModal],
		['dispatch', dispatcher],
		['displayHowToEarnPointsModal', displayHowToEarnPointsModal],
	],
)
